import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { SubscriptionInfoPublic } from '../fragments';

export default gql`
  mutation updateSubscription($input: SubscriptionUpdateInput!) {
    updateSubscription(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      subscription {
        ...SubscriptionInfoPublic
      }
    }
  }
  ${SubscriptionInfoPublic}
  ${ErrorMessageInfo}
`;
